import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-ai-badge',
  standalone: true,
  imports: [],
  templateUrl: './ai-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ai-badge.component.scss',
})
export class AiBadgeComponent {}
